import React from 'react';
import { Button, Card, notification, Modal } from 'antd';
import { useEffect, useState } from 'react';
import { deleteTax, getAllTax, postTax, updateTax } from 'utils/apis/configTax';
import TableComponent from './table/Table';
import { MainContainer } from './TaxConfig.styles';
import TaxModal from './TaxModal/TaxModal';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { buildAPBillingConfigPricingModelURI } from 'utils/routes';

const TaxConfig = ({ form }) => {
  const [isVisible, setVisible] = useState(false);
  const [isWarningVisible, setWarningVisible] = useState(false);

  const [taxData, setTaxData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedTax, setSelectedTax] = useState('');
  const [linkedPricingModelWarning, setLinkedPricingModelWarning] = useState([]);

  useEffect(() => {
    if (isWarningVisible) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'visible';
    }
    fetchData();
  }, [isWarningVisible]);

  const fetchData = async () => {
    setIsLoading(true); // Set loading state to true
    try {
      const response = await getAllTax();
      setTaxData(response.data); // Update tax data state with fetched data
      console.log(response.data);
    } catch (error) {
      console.error('Error fetching tax data:', error);
    } finally {
      setIsLoading(false); // Set loading state to false after fetching completes
    }
  };

  const handleSelectedTax = tax => {
    console.log(tax);
    setSelectedTax(tax);
    setVisible(true);
  };

  const showModal = () => {
    setVisible(true);
  };
  const closeModal = () => {
    setVisible(false);
  };
  const closeWarningModal = () => {
    setWarningVisible(false);
    setLinkedPricingModelWarning(''); // Optionally, reset any other state related to the Modal
    document.body.style.overflow = 'visible';
  };

  const handleSubmit = async (values, selectedTaxId) => {
    try {
      if (selectedTaxId === 'new') {
        await postTax(values);
        notification.success({
          message: 'Success',
          description: 'Tax has been created successfully.'
        });
      } else {
        await updateTax(selectedTaxId, values);
        notification.success({
          message: 'Success',
          description: 'Tax has been updated successfully.'
        });
      }
      setSelectedTax('');
      fetchData();
    } catch (error) {
      console.error('Error submitting tax:', error);
    }
  };
  const handleDelete = async selectedTaxId => {
    try {
      const tax = taxData.filter(tax => tax._id === selectedTaxId);
      console.log(tax);

      if (tax[0].linkedPricingModels.length) {
        console.log('asd');
        const linkedPricingModels = tax[0].linkedPricingModels;
        setLinkedPricingModelWarning(linkedPricingModels);
        setWarningVisible(true);
        return;
      }

      const deleted = await deleteTax(selectedTaxId);
      notification.success({
        message: 'Deleted',
        description: 'Tax has been deleted successfully.'
      });
      //console.log('Tax deleted successfully:', deleted);
      fetchData();
    } catch (error) {
      console.error('Error deleting tax:', error);
      notification.success({
        message: 'Deleted',
        description: `Encoutered Problem ${error}`
      });
    }
  };

  console.log(linkedPricingModelWarning);

  return (
    <MainContainer>
      <Button onClick={showModal} style={{ marginBottom: '40px' }} type="primary">
        Create Tax
      </Button>
      <Card>
        <TableComponent data={taxData} loading={isLoading} onSelectedTax={handleSelectedTax} />
      </Card>
      <TaxModal
        offVisible={closeModal}
        visibility={isVisible}
        fetchData={fetchData}
        selectedTax={selectedTax}
        onSubmit={handleSubmit}
        resetSelectedTax={() => setSelectedTax('')}
        onDelete={handleDelete}
      />
      {linkedPricingModelWarning && (
        <Modal
          title={
            <span>
              <ExclamationCircleOutlined style={{ color: 'red', marginRight: '8px' }} />
              Cannot Delete
            </span>
          }
          visible={isWarningVisible}
          onCancel={closeWarningModal}
          footer={null}
        >
          <p>This tax is linked to the following pricing model(s), please remove them before deleting:</p>
          <ul>
            {linkedPricingModelWarning.map((pricingModel, index) => (
              <li key={index}>
                <Link to={`${buildAPBillingConfigPricingModelURI()}/${pricingModel._id}/edit`}>{pricingModel.name}</Link>
              </li>
            ))}
          </ul>
        </Modal>
      )}
    </MainContainer>
  );
};

export default TaxConfig;
